import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  
  private appConfig: any = {
    "maintenaceMode": false,
    "maintenaceModeText": "This web page is currently undergoing maintenance.",
    "ForbiddenErrorTextMsg": "Your code is inactive, please contact your Business Owner.",
    "GenericErrorTextMsg": "Unable to complete your request - please try again."
  };

  constructor(private httpClient: HttpClient) { }


  loadAppConfig() {
    return this.httpClient.get<any>('assets/app.config.json').pipe(
      map((data: any) => {
        this.appConfig = data;
      }),
      catchError(error => {        
        console.error('Error loading configuration file:', error);
        // You can return a default config or handle the error as needed
        return of(null); // Return an observable with null value
      })
    );
  }

  getAppConfig(): any {
    return this.appConfig;
  }
}
